module.exports = __webpack_public_path__ + "img/mair.7779f849.svg";